import PropTypes from 'prop-types';
import React from 'react';
import Lazy from './lazy';
import { openTab } from '../../utils/dom';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import {partial} from 'lodash';

export const IMPRESSION_TRACKER_LAZY_LOAD_CUSHION_PX = 0;

const EVENT_CATEGORIES = {
  campaign: {
    label: 'Paid Content',
    linkType: 'outbound',
    pageModule: 'Branding Banner'
  },
  program: {
    label: 'Program Branding',
    linkType: 'channel',
    pageModule: 'Program Banner'
  }
};

const handleClick = (type, clickTracker, event) => {
  event.preventDefault();
  const { href } = event.currentTarget;
  const eventCategory = EVENT_CATEGORIES[type];
  const { label, linkType, pageModule } = eventCategory;
  sendAnalyticsEvent(
    label,
    'Click',
    { hitCallback: () => openTab(href) }
  );

  sendDataLayerEvent('Click', {
    linkURL: clickTracker,
    eventCallback: () => openTab(href),
    pageModule,
    linkType
  });
};

const handleLoad = (type) => {
  sendAnalyticsEvent(
    EVENT_CATEGORIES[type].label,
    'Impression',
    null,
    { nonInteraction: true }
  );

  sendDataLayerEvent('View', {
    pageModule: 'Branding Banner',
    linkType: 'outbound'
  });
};

const impressionTrackerBaseElement = (impressionTracker, type) => (
  <Lazy cushion={IMPRESSION_TRACKER_LAZY_LOAD_CUSHION_PX} >
    <img className="impression-tracker no-content"
      onLoad={partial(handleLoad, type, impressionTracker)}
      src={impressionTracker}
    />
  </Lazy>
);

const impressionTrackerElement = ({ impressionTracker, type }) =>
  impressionTracker
    ? impressionTrackerBaseElement(impressionTracker, type)
    : null;

const brandingImageBaseElement = (src, alt_title) => (
  <div className="branding">
    <img src={src} alt={alt_title} />
  </div>
);

const linkedBrandingImageElement = (src, type, clickTracker, noFollow, alt_title) => (
  <a href={clickTracker}
    rel={noFollow ? 'nofollow' : null}
    onClick={partial(handleClick, type, clickTracker)}
    target="_blank"
  >
    {brandingImageBaseElement(src, alt_title)}
  </a>
);

const brandingImageElement = ({ src, type, clickTracker, noFollow, alt_title }) => clickTracker
  ? linkedBrandingImageElement(src, type, clickTracker, noFollow, alt_title)
  : brandingImageBaseElement(src, alt_title);

const BrandingBanner = (props) => (
  <div className={`branding-banner ${props.type}`}>
    {impressionTrackerElement(props)}
    {brandingImageElement(props)}
  </div>
);

BrandingBanner.propTypes = {
  src: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'campaign',
    'program'
  ]).isRequired,
  clickTracker: PropTypes.string,
  impressionTracker: PropTypes.string,
  noFollow: PropTypes.bool,
  alt_title: PropTypes.string
};

BrandingBanner.defaultProps = {
  alt_title: ''
};

export default BrandingBanner;
